import ConfirmDialog from "../../../components/customHelpers/ConfirmDialog";
import Controls from "../../../components/controls/Controls";
import Norecords from "../../../components/customHelpers/Norecords";
import Loading from "../../../components/customHelpers/Loading";

import {
  TableBody,
  TableRow,
  TableCell,
  Typography,
  makeStyles,
} from "@material-ui/core";

import { Grid, Toolbar, InputAdornment } from "@material-ui/core";
import { useEffect, useState } from "react";

import { MdOutlineDelete } from "react-icons/md";
import { IoMdAdd } from "react-icons/io";
import { AiOutlineSearch } from "react-icons/ai";
import useTable from "../../../components/customHelpers/useTable";
import Notify from "../../../components/customHelpers/Notify";
import Notification from "../../../components/customHelpers/Notification";
import { FiEdit } from "react-icons/fi";

import Store from "../../../actions/store";
import AddStoreForm from "../../../components/forms/addStore";
import Popup from "../../../components/customHelpers/Popup";
import produce from "immer";
import { Paper } from "@mui/material";
const headCells = [
  { id: "name", label: "Name" },
  { id: "description", label: "Address" },

  { id: "actions", label: "Actions", disableSorting: true },
];

const StorePage = () => {
  const { NotifyMessage, notify, setNotify } = Notify();
  const { viewAllStores, deleteStore } = Store();
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [edite, setEdit] = useState(false);
  const [stores, setStores] = useState([]);
  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;
  useEffect(() => {
    getAllStores();
  }, [reload]);

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const getAllStores = () => {
    setValues({ ...values, loading: true });
    viewAllStores().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.stores) {
        setValues({
          ...values,
          loading: false,
        });
        setStores(data.stores);
      }
    });
  };
  const onDelete = (Id) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    deleteStore(Id).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else {
        NotifyMessage({
          message: data.message,
          type: "success",
        });
        setValues({ ...values, reload: !reload });
        setStores(
          produce(stores, (draft) => {
            const index = stores.findIndex((role) => role.id === Id);
            if (index !== -1) draft.splice(index, 1);
          })
        );
      }
    });
  };
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(stores, headCells, filterFn);

  const handleSearch = (e) => {
    e.target.value = e.target.value.trimLeft();
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        const columns = ["locationName", "locationAddress"];

        if (target.value == "") return items;
        else {
          return items.filter((x) => {
            return columns.some((column) => {
              return (
                x[column]
                  .toString()
                  .toLowerCase()
                  .indexOf(target.value.toLowerCase()) > -1
              );
            });
          });
        }
      },
    });
  };

  return (
    <>
      <div className="card">
        <Typography variant="h6" className="page-header">
          Stores
        </Typography>
        <Toolbar>
          <Controls.Input
            label="Search Store"
            className="searchInput"
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AiOutlineSearch />
                </InputAdornment>
              ),
            }}
            onChange={handleSearch}
          />

          <Controls.Button
            text="Add Store"
            variant="outlined"
            startIcon={<IoMdAdd />}
            className="newButton"
            onClick={() => {
              setOpenPopup(true);
              setRecordForEdit(null);
              setEdit(false);
            }}
          />
        </Toolbar>

        <Grid container>
          <Grid item xs={12} className="card__body">
            {loading ? (
              <Loading />
            ) : (
              <Paper style={{ overflowX: "auto" }}>
                <TblContainer>
                  <TblHead />
                  <TableBody>
                    {recordsAfterPagingAndSorting().length > 0 ? (
                      recordsAfterPagingAndSorting().map((item) => (
                        <TableRow key={item.Id}>
                          <TableCell>{item.locationName}</TableCell>
                          <TableCell>{item.locationAddress}</TableCell>
                          <TableCell>
                            <Controls.ActionButton
                              color="secondary"
                              title="Delete"
                              onClick={() => {
                                setConfirmDialog({
                                  isOpen: true,
                                  title: "Are you sure to delete this Store?",
                                  subTitle: "You can't undo this operation",
                                  onConfirm: () => {
                                    onDelete(item.id);
                                  },
                                });
                              }}
                            >
                              <MdOutlineDelete fontSize="medium" />
                            </Controls.ActionButton>
                            <Controls.ActionButton
                              color="primary"
                              title="Update"
                              onClick={() => {
                                setOpenPopup(true);
                                setRecordForEdit(item);
                                setEdit(true);
                              }}
                            >
                              <FiEdit fontSize="medium" />
                            </Controls.ActionButton>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <Norecords col={6} />
                    )}
                  </TableBody>
                </TblContainer>
                <TblPagination />
              </Paper>
            )}
          </Grid>
        </Grid>

        <ConfirmDialog
          confirmDialog={confirmDialog}
          setConfirmDialog={setConfirmDialog}
        />
        <Notification notify={notify} setNotify={setNotify} />
      </div>
      <Popup
        title="Store Form"
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
      >
        <AddStoreForm
          NotifyMessage={NotifyMessage}
          setOpenPopup={setOpenPopup}
          recordForEdit={recordForEdit}
          setStores={setStores}
          edite={edite}
        />
      </Popup>
    </>
  );
};

export default StorePage;
